export const POST_COMMENT_DATA = "POST_COMMENT_DATA";
export const POST_VIDEO_COMMENT_DATA = "POST_VIDEO_COMMENT_DATA";
export const POST_COMMENT_SECCUES = "POST_COMMENT_SECCUES";
export const POST_COMMENT_ERROR = "POST_COMMENT_ERROR";
